import React from 'react';

import { withStyles } from '@material-ui/core/styles';


//drop down field
import MenuItem from 'material-ui/MenuItem';
import { ValidatorForm,SelectValidator } from 'react-material-ui-form-validator';
import Button from '@material-ui/core/Button';

//API Gateway
import {API} from "aws-amplify";


const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 500,
  },
});

class AnnimationSelect extends React.Component {
  state = {
    topics:[],
    topic:'',
  };

    //Make GET request to get the list of topic
    async componentDidMount() {
  
        try {
          const topics = await this.getTopic();
          this.setState({ topics });
    
        } catch (e) {
          alert(e);
        }
      
        this.setState({ submitted: false });
      }
     // make call to API to get language for dropdown list
     getTopic() {
        return API.get("topic", "/topic");
      }

  // Topics Dropdown Menu change
  handleTopicFieldChange = (event, index, topic) => 
  {
      this.setState({topic});
      var topicName = topic;

      this.props.onChange(topicName);
  }

  selectionRenderer = (topics) => {
    switch (topics.length) {
      case 0:
        return '';
      case 1:
        return topics;
      default:
        return topics;
    }
  }

  menuItems(topics) {
    return topics.map((t) => (
      <MenuItem
        key={t.topic}
        insetChildren={true}
        checked={this.state.topics.indexOf(t.topic) > -1}
        value={t.topic}
        primaryText={t.topic}
      />
    ));
  }

  reset(event) {

    this.setState({  
      topic:''
  });

  this.props.onChange('','');  

  };
  render() {

    return (
      <div>

        <ValidatorForm
                ref="form"
                onSubmit={this.handleTopicFieldChange}

            >            
             <SelectValidator
                  floatingLabelText="Topic"
                  name= "topic"
                  autoWidth={true}
                  value={this.state.topic}
                  onChange={this.handleTopicFieldChange}
                  selectionRenderer={this.selectionRenderer}
                  
                >
                  {this.menuItems(this.state.topics.sort((a, b) => (a.topic < b.topic ? -1 : 1)))}
                </SelectValidator>
                <Button size="small" color="primary" onClick={ this.reset.bind(this)} style={{marginLeft:10, marginBottom:20}}>
                    Reset
                </Button>
        </ValidatorForm>
      </div>
    );
  }
}



export default withStyles(styles)(AnnimationSelect);